module.exports = "/images/selectHelpTopic.png?6b81cab5a89cc640c532796791065119";